import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth';
import { DevSessionProvider } from './lib/devSession';
import { BotAdminSessionProvider } from './lib/botAdminSession';
import { ThemeProvider } from './lib/theme';
import { DensityProvider } from './lib/density';
import { PinnedToolsProvider } from './lib/pinnedTools';
import { RecentActionsProvider } from './lib/recentActions';
import './fonts.css';
import './index.css';
import './theme.css';
import './vivid-theme.css';
import './slot-page-architecture.css';
import './crimson-noir.css';
import './botAdmin.mobile.css';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <DevSessionProvider>
              <BotAdminSessionProvider>
                <DensityProvider>
                  <PinnedToolsProvider>
                    <RecentActionsProvider>
                      <App />
                    </RecentActionsProvider>
                  </PinnedToolsProvider>
                </DensityProvider>
              </BotAdminSessionProvider>
            </DevSessionProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
